import React from 'react';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import DoubleInput from '../../../../../../components/NovoSistema/DoubleInput';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';

export default function Recalculo() {
  return (
    <main>
      <ContainerSection>
        <h3>Filtro</h3>
        <WrapperInputsNewSystem>
          <DoubleInput title="Produto" id="Produto" widthPercentage="100%" />
        </WrapperInputsNewSystem>
        <WrapperInputsNewSystem>
          <InputCheckBox title="Todos Produtos" id="TodosProdutos" />
        </WrapperInputsNewSystem>
        <ButtonsGeneric>
          <button className="normal">Carregar</button>
        </ButtonsGeneric>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="normal">Recalcular</button>
      </ButtonsGeneric>
    </main>
  );
}
